import axios from '@/plugins/axios';

export const updatePromissoryNote = async (documentId, form) => {
  const formData = new FormData();

  formData.append('_method', 'PUT');
  formData.append('customer_id', form.customerId);
  formData.append('user_id', form.userId);
  formData.append('promissory_note_amount', form.promissoryNoteAmount);
  formData.append('promissory_note_date', form.promissoryNoteDate);
  formData.append('bank_guarantee_name', form.bankGuaranteeName);

  if (form.promissoryNote instanceof File) {
    formData.append('promissory_note', form.promissoryNote);
  }

  const { data } = await axios.post(
    `/promissory-notes/update/${documentId}`,
    formData
  );

  return data;
};
